import { render, staticRenderFns } from "./AddBlockBtn.vue?vue&type=template&id=388399a0&"
import script from "./AddBlockBtn.vue?vue&type=script&lang=js&"
export * from "./AddBlockBtn.vue?vue&type=script&lang=js&"
import style0 from "./AddBlockBtn.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports